import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageRibbonComponent } from './page-ribbon/page-ribbon.component';
import { DemoInitRunnerService } from './core/demo-init-runner.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, PageRibbonComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Plaftware SST';

  constructor(private demoInit: DemoInitRunnerService) {}

  ngOnInit(): void {
    this.demoInit.runInBackground();
  }
}
